import { useContext as useRouterContext } from '@interhyp/platform-router';

export const useRouterIntentId = (): string | undefined => {
  const routerContext = useRouterContext();
  return routerContext?.id;
};
